export default "__VITE_ASSET__CUiH77lZ__"